import React, { useState } from "react";
// import BidsCard from "../components/BidsCard";
import HeroImage from "../Images/home_banner.png";
import "../scss/Homepage.scss";
import cloud from "../Images/cloud.png";
import respond from "../Images/respond.png";
import money from "../Images/money.png";
import map from "../Images/map.png";
import dollar from "../Images/dollar-1.png";
import icon from "../Images/icon.png";
import graph from "../Images/graph.png";
import currency from "../Images/currency.png";
import users from "../Images/users.png";
import bank from "../Images/bank.png";
import freedom from "../Images/freedom.png";
import flexibility from "../Images/flexibility.png";
import safety from "../Images/safety.png";
import arrow_one from "../Images/arrow-one.png";
import arrow_two from "../Images/arrow-two.png";
import { useGlobalContext } from "../components/Context";
// import { Link } from "react-router-dom";

const Homepage = () => {
	const [value, setValue] = useState({
		price: "0.1",
	});
	const { executeScroll } = useGlobalContext();

	const handleChange = (e) => {
		let newState = { ...value };
		newState[e.target.name] = e.target.value;
		setValue({
			...newState
		})
	};

	

	return (
		<div className="homepage">
			<div className="homepage__wrapper">
				<div className="homepage__heroContainer">
					<div className="homepage__hero">
						<div className="homepage__heroLeft">
							<p className="homepage__heroLeft__title">
								Exchange currencies the easy and secure way.{" "}
							</p>
							<p className="homepage__heroLeft__subtitle">
								iExchange is a currency marketplace that allows users to track,
								spend, send and convert from one currency to another securely,
								cheaply and without borders.{" "}
							</p>
							<button onClick={executeScroll} >Join Wait List</button>
							
						</div>
						<div className="homepage__heroRight">
							<img src={HeroImage} alt="heroimage" />
						</div>
					</div>
					<div className="homepage__conversion">
						<div className="homepage__conversion__wrapper">
							<p>What commodity do you want</p>
							<div className="homepage__conversion__bottom">
								<div>
									<input
										type="number"
										value={value.price}
										name="price"
										onChange={handleChange}
										placeholder="Please enter a value"
									/>
									<select name="" id="">
										<option value="USD">USD</option>
									</select>
								</div>
								<div>
									<button className="homepage__conversion__buy">
										BUY <img src={arrow_two} alt="" />
									</button>
									<button className="homepage__conversion__sell">
										SELL <img src={arrow_one} alt="" />
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* <div className="homepage__bidWrapper">
					<BidsCard />
					<BidsCard />
					<BidsCard />
				</div> */}

				<div className="homepage__working">
					<p className="homepage__working__heading">How It Works</p>
					<p className="homepage__working__subheading">Simple and Secured</p>
					<hr />
					<div className="homepage__working__cardWrapper">
						<div className="homepage__working__card">
							<img src={cloud} alt="cloud" />
							<p className="homepage__working__cardTitle">Create an account</p>
							<p className="homepage__working__cardSubtitle">
								Create an account in minutes
							</p>
						</div>
						<div className="homepage__working__card">
							<img src={respond} alt="respond" />
							<p className="homepage__working__cardTitle">
								Create or Respond to a Request
							</p>
							<p className="homepage__working__cardSubtitle">
								Tell us about your currency needs
							</p>
						</div>
						<div className="homepage__working__card">
							<img src={money} alt="money" />
							<p className="homepage__working__cardTitle">Exchange Currency</p>
							<p className="homepage__working__cardSubtitle">
								Securely exchange your currency
							</p>
						</div>
					</div>
				</div>

				<div className="homepage__map">
					<div className="homepage__mapleft">
						<img src={map} alt="" />
					</div>
					<div className="homepage__mapRight">
						<p className="homepage__map__title">
							{" "}
							<span>iExchange</span> - The Currency Marketplace
						</p>
						<p className="homepage__map__subtitle">
							iExchange is a peer-to-peer and currency broker powered currency
							marketplace. We facilitate cross border payment globally giving
							our users the opportunity to set their exchange rate and send
							money across borders.
						</p>
					</div>
				</div>

				<div className="homepage__benefit">
					<p className="homepage__benefit__heading">
						Benefits of using our platform
					</p>
					<div className="homepage__benefit__wrapper">
						<div className="homepage__benefit__card">
							<div>
								<div>
									<img src={dollar} alt="" />
								</div>

								<p>Dollar Card when needed</p>
							</div>
							<p>
								Get access to a virtual dollar card in minutes that ensures you
								are no more limited by your bank
							</p>
						</div>

						<div className="homepage__benefit__card">
							<div>
								<div>
									<img src={bank} alt="" />
								</div>
								<p>Exchange without Borders</p>
							</div>
							<p>
								Transact with anyone and from anywhere in the world. You aren’t
								limited by your geographical location.
							</p>
						</div>

						<div className="homepage__benefit__card">
							<div>
								<div>
									<img src={freedom} alt="" />
								</div>
								<p>Exchange with Freedom</p>
							</div>
							<p>Determine your exchange rate and transact</p>
						</div>

						<div className="homepage__benefit__card">
							<div>
								<div>
									<img src={flexibility} alt="" />
								</div>
								<p>Exchange Flexibility</p>
							</div>
							<p>
								Get access to partner currency brokers around you offering the
								best rate possible.
							</p>
						</div>

						<div className="homepage__benefit__card">
							<div>
								<div>
									<img src={safety} alt="" />
								</div>
								<p>Safety Guaranteed</p>
							</div>
							<p>
								Our platform incorporates a digital escrow system that helps
								build trust between buyers and sellers enforcing services are
								delivered on agreed terms
							</p>
						</div>
					</div>
				</div>

				<div className="homepage__question">
					<p className="homepage__question__heading">Why iExchange</p>
					<p className="homepage__question__subheading">
						Convert, Track, Spend
					</p>
					<hr />
					<div className="homepage__question__cardWrapper">
						<div className="homepage__question__card">
							<div>
								<img src={icon} alt="" />
							</div>

							<p className="homepage__question__cardTitle">
								Exchange without borders
							</p>
							<p className="homepage__question__cardSubtitle">
								Don't be limited by your geopraphical location
							</p>
						</div>
						<div className="homepage__question__card">
							<div>
								<img src={icon} alt="" />
							</div>
							<p className="homepage__question__cardTitle">Safe And Secure</p>
							<p className="homepage__question__cardSubtitle">
								Platform is equipped with a digital escrow system to guarantee
								the safety of yourfunds and keep fraudsters away.
							</p>
						</div>
						<div className="homepage__question__card">
							<div>
								<img src={icon} alt="" />
							</div>
							<p className="homepage__question__cardTitle">
								Virtual Dollar Card
							</p>
							<p className="homepage__question__cardSubtitle">
								Activate your virtual dollar card in minutes to enable you spend
								on your terms
							</p>
						</div>

						<div className="homepage__question__card">
							<div>
								<img src={icon} alt="" />
							</div>
							<p className="homepage__question__cardTitle">User-Friendly</p>
							<p className="homepage__question__cardSubtitle">
								We provide people centric technology to guarantee a seamless
								exchange experience
							</p>
						</div>
					</div>
				</div>

				<div className="homepage__transaction">
					<div className="homepage__transactionleft">
						<img src={graph} alt="" />
					</div>
					<div className="homepage__transactionRight">
						<p className="homepage__transaction__title">
							We make transacting across different currencies safe, simple and
							rewarding.
						</p>

						<div className="homepage__transaction__subtitle">
							<img src={currency} alt="" />
							<p>Cryptocurrencies, Fiat currencies, Gift cards, Airtime etc.</p>
						</div>
					</div>
				</div>

				<div className="homepage__user">
					<div className="homepage__userLeft">
						<p className="homepage__user__title">
							What our Million Smart <span>User Says.</span>
						</p>
						<p className="homepage__user__subtitle">
							More than one million users trust us to sell, buy, and trade the
							currencies in iExchange
						</p>

						<div></div>
					</div>
					<div className="homepage__userRight">
						<img src={users} alt="" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Homepage;
